module.exports = __webpack_public_path__ + "static/media/arena.b5ec72cb.jpg";